import { useState, Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Fab from "@mui/material/Fab";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Sidebar from "../components/Sidebar";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../actions/auth";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import { themeStyle } from "../components/Components";

function Events() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [select, setSelect] = useState("EVENTS");

  const handleSelect = (value) => {
    setSelect(value);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handlePageSelect = (event) => {
    setSelectedPage(event.currentTarget.value);
  };

  const [selectedPage, setSelectedPage] = useState(
    params.get("tab") ? params.get("tab") : "EVENTS"
  );
  const colorList = [
    "#e5f5f9",
    "#e0ecf4",
    "#fee8c8",
    "#ece7f2",
    "#f0f0f0",
    "#fde0dd",
    "#efedf5",
    "#e5f5e0",
    themeStyle.primaryColorLight,
    "#fee6ce",
  ];

  const [isLoading, setIsLoading] = useState(true);
  const [eventsList, setEventsList] = useState([]);
  const [eventsListBefore, setEventsListBefore] = useState([]);

  const [importantDatesList, setimportantDatesList] = useState([]);
  const [importantDatesListBefore, setimportantDatesListBefore] = useState([]);

  const [holidayList, setHolidayList] = useState([]);
  const [holidayListBefore, setHolidayListBefore] = useState([]);

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);

    axios.post(API_URL + "/get_events_list", body, config).then((res) => {
      var tempEvents = [];
      var tempEventsBefore = [];
      var tempImportantDates = [];
      var tempImportantDatesBefore = [];
      var tempHoliday = [];
      var tempHolidayBefore = [];

      for (let i = 0; i < res.data["events_list"].length; i++) {
        if (
          moment(res.data["events_list"][i]["date"], "DD-MM-YYYY").isBefore(
            moment()
          )
        ) {
          tempEventsBefore.push(res.data["events_list"][i]);
        } else {
          tempEvents.push(res.data["events_list"][i]);
        }
      }

      for (let i = 0; i < res.data["important_dates_list"].length; i++) {
        if (
          moment(
            res.data["important_dates_list"][i]["date"],
            "DD-MM-YYYY"
          ).isBefore(moment())
        ) {
          tempImportantDatesBefore.push(res.data["important_dates_list"][i]);
        } else {
          tempImportantDates.push(res.data["important_dates_list"][i]);
        }
      }

      for (let i = 0; i < res.data["holidays_list"].length; i++) {
        if (
          moment(res.data["holidays_list"][i]["date"], "DD-MM-YYYY").isBefore(
            moment()
          )
        ) {
          tempHolidayBefore.push(res.data["holidays_list"][i]);
        } else {
          tempHoliday.push(res.data["holidays_list"][i]);
        }
      }

      setEventsList(tempEvents);
      setHolidayList(tempHoliday);
      setimportantDatesList(tempImportantDates);
      setEventsListBefore(tempEventsBefore);
      setHolidayListBefore(tempHolidayBefore);
      setimportantDatesListBefore(tempImportantDatesBefore);
      setIsLoading(false);
    });
  }
  var colorIndex = 0;

  function getContent() {
    if (selectedPage == "EVENTS") {
      return (
        <div>
          <div
            style={{
              color: themeStyle.primaryColor,
              fontSize: "25px",
              marginBottom: "10px",
            }}
          >
            Upcoming Events
          </div>
          <Grid container spacing={1.5}>
            {eventsList.length == 0 ? (
              <div
                style={{
                  marginTop: "200px",
                  height: "100px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Fab
                    size="large"
                    style={{
                      border: "3px solid #aaa",
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    }}
                    aria-label="add"
                  >
                    <PriorityHighIcon
                      style={{
                        color: "grey",
                      }}
                    />
                  </Fab>
                  <br />
                  <h4 style={{ color: "grey" }}>No upcoming events.</h4>
                </div>
              </div>
            ) : (
              ""
            )}
            {eventsList.map((event, index) => (
              <Grid item md={4}>
                <span style={{ display: "none" }}>
                  {(colorIndex = Math.floor(Math.random() * colorList.length))}
                </span>

                <Box
                  padding={1}
                  borderRadius="5px"
                  sx={{ "&:hover": { opacity: "1 !important" } }}
                  style={{
                    opacity: "1",

                    minHeight: "100%",
                    borderRadius: "15px",
                    border: "2px solid " + themeStyle.primaryColorLight,
                    backgroundColor: colorList[colorIndex],
                    boxShadow: "none",
                    marginBottom: "5px",
                    height: "100%",
                  }}
                >
                  <Box style={{ marginLeft: "5px" }}>
                    <div
                      style={{
                        color: themeStyle.secondaryColor,
                        fontSize: "19px",
                        fontWeight: "bold",
                      }}
                    >
                      {event["name"]}
                    </div>
                    <div
                      style={{
                        fontSize: "15px",
                        color: "grey",
                      }}
                    >
                      {moment(event["date"], "DD-MM-YYYY").format(
                        "Do MMMM, YYYY"
                      )}
                    </div>
                    <div
                      style={{
                        fontSize: "15px",
                      }}
                    >
                      {event["venue"]}
                    </div>
                    <div
                      style={{
                        margin: "10px 0px 0px 0px",
                        fontSize: "15px",
                      }}
                    >
                      {event["description"]}
                    </div>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
          <br />
          <br />
          <div
            style={{
              color: themeStyle.primaryColor,
              fontSize: "25px",
              marginBottom: "10px",
            }}
          >
            Previous Events
          </div>
          <Grid container spacing={1.5}>
            {eventsList.length == 0 ? (
              <div
                style={{
                  marginTop: "200px",
                  height: "100px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Fab
                    size="large"
                    style={{
                      border: "3px solid #aaa",
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    }}
                    aria-label="add"
                  >
                    <PriorityHighIcon
                      style={{
                        color: "grey",
                      }}
                    />
                  </Fab>
                  <br />
                  <h4 style={{ color: "grey" }}>No upcoming events.</h4>
                </div>
              </div>
            ) : (
              ""
            )}
            {eventsListBefore.map((event, index) => (
              <Grid item md={4}>
                <Box
                  padding={1}
                  borderRadius="5px"
                  sx={{ "&:hover": { opacity: "1 !important" } }}
                  style={{
                    opacity: "1",

                    minHeight: "100%",
                    borderRadius: "15px",
                    border: "2px solid " + themeStyle.primaryColorLight,
                    backgroundColor: moment(
                      event["date"],
                      "DD-MM-YYYY"
                    ).isBefore(moment())
                      ? "white"
                      : themeStyle.primaryColorLight,
                    boxShadow: "none",
                    marginBottom: "5px",
                    height: "100%",
                  }}
                >
                  <Box style={{ marginLeft: "5px" }}>
                    <div
                      style={{
                        color: themeStyle.secondaryColor,
                        fontSize: "19px",
                        fontWeight: "bold",
                      }}
                    >
                      {event["name"]}
                    </div>
                    <div
                      style={{
                        fontSize: "15px",
                        color: "grey",
                      }}
                    >
                      {moment(event["date"], "DD-MM-YYYY").format(
                        "Do MMMM, YYYY"
                      )}
                    </div>
                    <div
                      style={{
                        fontSize: "15px",
                      }}
                    >
                      {event["venue"]}
                    </div>
                    <div
                      style={{
                        margin: "10px 0px 0px 0px",
                        fontSize: "15px",
                      }}
                    >
                      {event["description"]}
                    </div>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </div>
      );
    } else if (selectedPage == "DATES") {
      return (
        <div>
          <div
            style={{
              color: themeStyle.primaryColor,
              fontSize: "25px",
              marginBottom: "10px",
            }}
          >
            Upcoming Dates
          </div>
          <Grid container spacing={1.5}>
            {importantDatesList.length == 0 ? (
              <div
                style={{
                  marginTop: "200px",
                  height: "100px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Fab
                    size="large"
                    style={{
                      border: "3px solid #aaa",
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    }}
                    aria-label="add"
                  >
                    <PriorityHighIcon
                      style={{
                        color: "grey",
                      }}
                    />
                  </Fab>
                  <br />
                  <h4 style={{ color: "grey" }}>
                    No upcoming important dates.
                  </h4>
                </div>
              </div>
            ) : (
              ""
            )}
            {importantDatesList.map((date, index) => (
              <Grid item md={3}>
                <span style={{ display: "none" }}>
                  {(colorIndex = Math.floor(Math.random() * colorList.length))}
                </span>
                <Box
                  padding={1}
                  borderRadius="5px"
                  sx={{ "&:hover": { opacity: "1 !important" } }}
                  style={{
                    opacity: "1",
                    minHeight: "100%",
                    borderRadius: "15px",
                    border: "2px solid " + themeStyle.primaryColorLight,
                    backgroundColor: colorList[colorIndex],

                    boxShadow: "none",
                    marginBottom: "5px",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      margin: "0px 0px 0px 10px",
                    }}
                  >
                    <b
                      style={{
                        color: themeStyle.secondaryColor,
                        fontSize: "18px",
                      }}
                    >
                      {date["name"]}
                    </b>
                    <br></br>
                    <span style={{}}>
                      {moment(date["date"], "DD-MM-YYYY").format(
                        "Do MMMM, YYYY"
                      )}
                    </span>
                  </div>
                </Box>
              </Grid>
            ))}
          </Grid>
          <br />
          <br />
          <div
            style={{
              color: themeStyle.primaryColor,
              fontSize: "25px",
              marginBottom: "10px",
            }}
          >
            Previous Dates
          </div>
          <Grid container spacing={1.5}>
            {importantDatesListBefore.length == 0 ? (
              <div
                style={{
                  marginTop: "200px",
                  height: "100px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Fab
                    size="large"
                    style={{
                      border: "3px solid #aaa",
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    }}
                    aria-label="add"
                  >
                    <PriorityHighIcon
                      style={{
                        color: "grey",
                      }}
                    />
                  </Fab>
                  <br />
                  <h4 style={{ color: "grey" }}>
                    No upcoming important dates.
                  </h4>
                </div>
              </div>
            ) : (
              ""
            )}
            {importantDatesList.map((date, index) => (
              <Grid item md={3}>
                <Box
                  padding={1}
                  borderRadius="5px"
                  sx={{ "&:hover": { opacity: "1 !important" } }}
                  style={{
                    opacity: "1",
                    minHeight: "100%",
                    borderRadius: "15px",
                    border: "2px solid " + themeStyle.primaryColorLight,
                    backgroundColor: "white",
                    boxShadow: "none",
                    marginBottom: "5px",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      margin: "0px 0px 0px 10px",
                    }}
                  >
                    <b
                      style={{
                        color: themeStyle.secondaryColor,
                        fontSize: "18px",
                      }}
                    >
                      {date["name"]}
                    </b>
                    <br></br>
                    <span style={{}}>
                      {moment(date["date"], "DD-MM-YYYY").format(
                        "Do MMMM, YYYY"
                      )}
                    </span>
                  </div>
                </Box>
              </Grid>
            ))}
          </Grid>
        </div>
      );
    } else if (selectedPage == "HOLIDAYS") {
      return (
        <div>
          <div
            style={{
              color: themeStyle.primaryColor,
              fontSize: "25px",
              marginBottom: "10px",
            }}
          >
            Upcoming Holidays
          </div>
          <Grid container spacing={1.5}>
            {holidayList.length == 0 ? (
              <div
                style={{
                  marginTop: "200px",
                  height: "100px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Fab
                    size="large"
                    style={{
                      border: "3px solid #aaa",
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    }}
                    aria-label="add"
                  >
                    <PriorityHighIcon
                      style={{
                        color: "grey",
                      }}
                    />
                  </Fab>
                  <br />
                  <h4 style={{ color: "grey" }}>No upcoming holidays.</h4>
                </div>
              </div>
            ) : (
              ""
            )}
            {holidayList.map((holiday, index) => (
              <Grid item md={3}>
                <span style={{ display: "none" }}>
                  {(colorIndex = Math.floor(Math.random() * colorList.length))}
                </span>
                <Box
                  borderRadius="5px"
                  padding={1}
                  sx={{ "&:hover": { opacity: "1 !important" } }}
                  style={{
                    opacity: "1",
                    minHeight: "100%",
                    borderRadius: "15px",
                    border: "2px solid " + themeStyle.primaryColorLight,
                    backgroundColor: colorList[colorIndex],

                    boxShadow: "none",
                    marginBottom: "5px",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      margin: "0px 0px 0px 10px",
                    }}
                  >
                    <b
                      style={{
                        color: themeStyle.secondaryColor,
                        fontSize: "18px",
                      }}
                    >
                      {holiday["name"]}
                    </b>
                    <br></br>
                    <span style={{}}>
                      {moment(holiday["date"], "DD-MM-YYYY").format(
                        "Do MMMM, YYYY"
                      )}
                    </span>
                  </div>
                </Box>
              </Grid>
            ))}
          </Grid>
          <br />
          <br />
          <div
            style={{
              color: themeStyle.primaryColor,
              fontSize: "25px",
              marginBottom: "10px",
            }}
          >
            Previous Holidays
          </div>
          <Grid container spacing={1.5}>
            {holidayList.length == 0 ? (
              <div
                style={{
                  marginTop: "200px",
                  height: "100px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Fab
                    size="large"
                    style={{
                      border: "3px solid #aaa",
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    }}
                    aria-label="add"
                  >
                    <PriorityHighIcon
                      style={{
                        color: "grey",
                      }}
                    />
                  </Fab>
                  <br />
                  <h4 style={{ color: "grey" }}>No upcoming holidays.</h4>
                </div>
              </div>
            ) : (
              ""
            )}
            {holidayListBefore.map((holiday, index) => (
              <Grid item md={3}>
                <Box
                  borderRadius="5px"
                  padding={1}
                  sx={{ "&:hover": { opacity: "1 !important" } }}
                  style={{
                    opacity: "1",
                    minHeight: "100%",
                    borderRadius: "15px",
                    border: "2px solid " + themeStyle.primaryColorLight,
                    backgroundColor: "white",
                    boxShadow: "none",
                    marginBottom: "5px",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      margin: "0px 0px 0px 10px",
                    }}
                  >
                    <b
                      style={{
                        color: themeStyle.secondaryColor,
                        fontSize: "18px",
                      }}
                    >
                      {holiday["name"]}
                    </b>
                    <br></br>
                    <span style={{}}>
                      {moment(holiday["date"], "DD-MM-YYYY").format(
                        "Do MMMM, YYYY"
                      )}
                    </span>
                  </div>
                </Box>
              </Grid>
            ))}
          </Grid>
        </div>
      );
    }
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (isLoading) {
        return (
          <Fragment>
            <Sidebar />
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                backgroundColor: "white",
                marginTop: "46vh",
              }}
            >
              <CircularProgress />
            </div>
          </Fragment>
        );
      } else {
        return (
          <Fragment>
            <Sidebar
              tabs={
                <Grid container spacing={1.5}>
                  <Grid item md={4}>
                    {selectedPage == "EVENTS" ? (
                      <Button
                        fullWidth
                        value={"EVENTS"}
                        onClick={handlePageSelect}
                        p={2}
                        style={{
                          backgroundColor: themeStyle.primaryColor,
                          color: "white",
                          height: "30px",
                        }}
                        borderRadius={6}
                      >
                        <h3
                          style={{
                            marginTop: "17px",
                            fontSize: "15px",
                          }}
                        >
                          EVENTS
                        </h3>
                      </Button>
                    ) : (
                      <Button
                        fullWidth
                        value={"EVENTS"}
                        onClick={handlePageSelect}
                        p={2}
                        style={{
                          backgroundColor: themeStyle.primaryColorLight,
                          color: "white",
                          height: "30px",
                        }}
                        borderRadius={6}
                      >
                        <h3
                          style={{
                            marginTop: "17px",
                            fontSize: "15px",
                            color: themeStyle.secondaryColor,
                          }}
                        >
                          EVENTS
                        </h3>
                      </Button>
                    )}
                  </Grid>
                  <Grid item md={4}>
                    {selectedPage == "DATES" ? (
                      <Button
                        fullWidth
                        value="DATES"
                        onClick={handlePageSelect}
                        p={2}
                        style={{
                          backgroundColor: themeStyle.primaryColor,
                          color: "white",
                          height: "30px",
                        }}
                        borderRadius={6}
                      >
                        <h3
                          style={{
                            marginTop: "17px",
                            fontSize: "15px",
                          }}
                        >
                          DATES
                        </h3>
                      </Button>
                    ) : (
                      <Button
                        fullWidth
                        value="DATES"
                        onClick={handlePageSelect}
                        p={2}
                        style={{
                          backgroundColor: themeStyle.primaryColorLight,
                          color: "white",
                          height: "30px",
                        }}
                        borderRadius={6}
                      >
                        <h3
                          style={{
                            marginTop: "17px",
                            fontSize: "15px",
                            color: themeStyle.secondaryColor,
                          }}
                        >
                          DATES
                        </h3>
                      </Button>
                    )}
                  </Grid>
                  <Grid item md={4}>
                    {selectedPage == "HOLIDAYS" ? (
                      <Button
                        fullWidth
                        value="HOLIDAYS"
                        onClick={handlePageSelect}
                        p={2}
                        style={{
                          backgroundColor: themeStyle.primaryColor,
                          color: "white",
                          height: "30px",
                        }}
                        borderRadius={6}
                      >
                        <h3
                          style={{
                            marginTop: "17px",
                            fontSize: "15px",
                          }}
                        >
                          HOLIDAYS
                        </h3>
                      </Button>
                    ) : (
                      <Button
                        fullWidth
                        value="HOLIDAYS"
                        onClick={handlePageSelect}
                        p={2}
                        style={{
                          backgroundColor: themeStyle.primaryColorLight,
                          color: "white",
                          height: "30px",
                        }}
                        borderRadius={6}
                      >
                        <h3
                          style={{
                            marginTop: "17px",
                            fontSize: "15px",
                            color: themeStyle.secondaryColor,
                          }}
                        >
                          HOLIDAYS
                        </h3>
                      </Button>
                    )}
                  </Grid>
                </Grid>
              }
            />
            <div
              style={{
                margin: "65px 15px 20px 85px",
                backgroundColor: "white",
              }}
            >
              {getContent()}
            </div>
          </Fragment>
        );
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}
export default Events;
